import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { useI18n } from '@/providers/i18n';

import { paymentSchema, type PaymentValues } from '../schemas';
import styles from './CheckoutPayment.module.css';
import StepHeader from './StepHeader';

interface CheckoutPaymentProps {
  onBack: () => void;
  onSubmit: (values: PaymentValues) => void;
}

export default function CheckoutPayment({ onBack, onSubmit }: CheckoutPaymentProps) {
  const { t } = useI18n();
  const form = useForm<PaymentValues>({
    resolver: zodResolver(paymentSchema),
    defaultValues: { card: '', exp: '', cvc: '' },
  });

  const { errors } = form.formState;

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <StepHeader step={3} label={t('checkout.payment')} />
      <div className={styles.form}>
        <div className="field">
          <label htmlFor="co-card">{t('checkout.card')}</label>
          <input
            id="co-card"
            placeholder="0000 0000 0000 0000"
            {...form.register('card')}
          />
          {errors.card && <span className="err">{errors.card.message}</span>}
        </div>
        <div className={styles.row2}>
          <div className="field">
            <label htmlFor="co-exp">{t('checkout.exp')}</label>
            <input id="co-exp" placeholder="MM / YY" {...form.register('exp')} />
            {errors.exp && <span className="err">{errors.exp.message}</span>}
          </div>
          <div className="field">
            <label htmlFor="co-cvc">{t('checkout.cvc')}</label>
            <input id="co-cvc" placeholder="000" {...form.register('cvc')} />
            {errors.cvc && <span className="err">{errors.cvc.message}</span>}
          </div>
        </div>
        <p className="micro fg-dim">MOCK CHECKOUT · NO REAL TRANSACTION</p>
      </div>
      <div className={styles.actions}>
        <button type="button" className="btn btn-ghost" onClick={onBack}>
          {t('cta.back')}
        </button>
        <button type="submit" className="btn btn-fill btn-arrow">
          {t('cta.confirm')}
        </button>
      </div>
    </form>
  );
}
